import { FC } from 'react';
import { PaymentMethodId } from '@commerce-payment-webcomponents/sdk';
import { Button, ButtonSize, useNextgenRouter, useTranslation } from '@nextgen-web-framework/all';
import styles from './QuantityContainer.module.scss';
import TotalAmount from './components/total-amount/TotalAmount';
import MessageWithDrawer from './components/message-with-drawer/MessageWithDrawer';
import { QuantityContainerPropTypes } from './types/propTypes';

export const QuantityContainer: FC<QuantityContainerPropTypes> = ({
  amount,
  paymentMethodId,
  viewBtnClick,
  expiringPoints,
  expiringDate,
  redeemNowHandler,
  showRedeemNowButton,
}: QuantityContainerPropTypes) => {
  const t = useTranslation();
  const router = useNextgenRouter();
  const showMessageDrawer =
    (paymentMethodId == PaymentMethodId.AmwayPoints && expiringPoints && expiringPoints != '0') ||
    paymentMethodId == PaymentMethodId.CreditVoucher;
  const isRedeemButtonVisible =
    showRedeemNowButton && paymentMethodId == PaymentMethodId.AmwayPoints && amount && amount > 0;

  return (
    <div className={styles['quantity-container']} data-testid="quantity-container">
      <TotalAmount amount={amount} paymentMethodId={paymentMethodId} />
      {showMessageDrawer && (
        <MessageWithDrawer
          paymentMethodId={paymentMethodId}
          viewBtnClick={viewBtnClick}
          expiringPoints={expiringPoints}
          expiringDate={expiringDate}
          redeemNowHandler={redeemNowHandler}
        />
      )}
      {isRedeemButtonVisible && (
        <div className={styles['redeem-button-container']}>
          <Button
            data-testid="redeem-button"
            title={t('payment.internalOptions.redeemYourPointNow')}
            size={ButtonSize.SMALL}
            onClick={() => {
              router.push('/a-point-catalog');
            }}
          />
        </div>
      )}
    </div>
  );
};
